import React, { useState, useMemo } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';
import { FileCopySharp } from '@material-ui/icons';
import Button from 'components/CustomButtons/Button.js';
import moment from 'moment';
//iconos
import { Add } from '@material-ui/icons';

//tabla y card components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTableV2.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import { TextField } from '@material-ui/core';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

//servicios
import { wsFindBy, wsPost } from 'services/WService.js';

//modal
import Modal from './Modal';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';
import FilterCustom from 'components/Tvendo/Common/FilterCustom';
import { wsUpdate } from 'services/WService';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
    fontSize: '16px',
    display: 'flex',
    alignItems: 'baseline',
  },
  headerCard: {
    fontSize: '.9em',
    '& .totals': {
      marginLeft: '20px',
      fontWeight: 'bold',
      color: 'black',
    },
  },
  loader: {
    marginLeft: '20px',
  },
};
const useStyles = makeStyles(styles);

//columnas para llenar la tabla
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 130 },
  { Header: 'Periodo', accessor: 'Periodo', width: 100 },
  { Header: 'Zona', accessor: 'description_zone' },  
  { Header: 'Grupo Comision', accessor: 'grupo_d_description' },
  { Header: 'Trabajador', accessor: 'tipo_t_description' },
  { Header: 'Peso', accessor: 'peso', excelEnabled: false },
  { Header: 'Peso', accessor: 'peso_string', hidden: true },
  { Header: 'Importe Comision', accessor: 'importe_comision', excelEnabled: false},
  { Header: 'Importe Comision', accessor: 'importe_comision_string', hidden: true },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

export default WithApp(function Colgate(props) {
  const classes = useStyles();

  const [model, setOpen] = useModal();
  const [notify, showNotify] = useToasty();
  const [cuotas, setCuotas] = useState([]);
  const [valueSearch, setValueSearch] = useState({});
  const [isDataReady, setIsDataReady] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [currentPeriod, setCurrentPeriod] = useState(null);

  const handleChange = (id, field, value) => {
    const index = cuotas.findIndex((item) => item.id == id);
    cuotas[index][field] = value;
    setCuotas([...cuotas]);
  };
  
  async function loadCuotas(filter) {
    setDataLoading(true);
    setIsDataReady(false);
    let response = await wsFindBy('sale/bono-zone', filter);
    setDataLoading(false);
    if (response.success) {
      setCuotas(response.data);
      setIsDataReady(true);
      notifyWeight(response.data, filter);
    }
  }
  
  async function updateCuota(id, field, value) {
    setDataLoading(true);
    let response = await wsUpdate('sale/bono-zone', id, { [field]: value });
    setDataLoading(false);
    if (response.success) {
      showNotify(response.message);
      console.log('Datos devueltos: ', response.data);
      loadCuotas(valueSearch);
    } else {
      showNotify(response.message, 'error');
      loadCuotas(valueSearch);
    }
  }

  const totalComision = useMemo(() => {
    return cuotas.reduce(
      (acc, cuota) => acc + parseFloat(cuota.importe_comision || 0),
      0
    ).toFixed(2);
  }, [cuotas]);
  
  const pesoTotals = useMemo(() => {
    const totals = {};
  
    if (!isDataReady || (!valueSearch.zone_code && !valueSearch.grupo_d_description && !valueSearch.type_worker_code)) {
      return totals;
    }
  
    cuotas.forEach((cuota) => {
      if (valueSearch.zone_code && cuota.zone_code === valueSearch.zone_code) {
        totals[cuota.zone_code] = (totals[cuota.zone_code] || 0) + parseFloat(cuota.peso || 0);
      }
      if (valueSearch.grupo_d_description && cuota.grupo_d_description === valueSearch.grupo_d_description) {
        totals[cuota.grupo_d_description] = (totals[cuota.grupo_d_description] || 0) + parseFloat(cuota.peso || 0);
      }
      if (valueSearch.type_worker_code && cuota.type_worker_code === valueSearch.type_worker_code) {
        totals[cuota.type_worker_code] = (totals[cuota.type_worker_code] || 0) + parseFloat(cuota.peso || 0);
      }
    });
    
    return Object.keys(totals).reduce((acc, key) => {
      acc[key] = totals[key].toFixed(2);
      return acc;
    }, {});
  }, [cuotas, isDataReady, valueSearch]);

  function notifyWeight(data, filter) {
    const isBaseZoneFiltered = !!filter.zone_code;
    const isGroupCommissionFiltered = !!filter.grupo_d_description;
    const isTypeWorkerFiltered = !!filter.type_worker_code;

    if (isBaseZoneFiltered && isGroupCommissionFiltered && isTypeWorkerFiltered) {
      const totals = {};

      data.forEach((cuota) => {
        if (filter.zone_code && cuota.zone_code === filter.zone_code) {
          totals[filter.zone_code] = (totals[filter.zone_code] || 0) + parseFloat(cuota.peso || 0);
        }
        if (filter.grupo_d_description && cuota.grupo_d_description === filter.grupo_d_description) {
          totals[filter.grupo_d_description] =
            (totals[filter.grupo_d_description] || 0) + parseFloat(cuota.peso || 0);
        }
        if (filter.type_worker_code && cuota.type_worker_code === filter.type_worker_code) {
          totals[filter.type_worker_code] =
            (totals[filter.type_worker_code] || 0) + parseFloat(cuota.peso || 0);
        }
      });

      const pesoCombinado = Math.max(
        totals[filter.zone_code] || 0,
        totals[filter.grupo_d_description] || 0,
        totals[filter.type_worker_code] || 0
      );

      if (pesoCombinado === 100) {
        showNotify(`El peso total es del 100%.`, 'success');
      } else if (pesoCombinado > 100) {
        showNotify(`El peso total excede el 100% (${pesoCombinado}%).`, 'error');
      } else {
        showNotify(`El peso total es menor al 100% (${pesoCombinado}%).`, 'warning');
      }
    }
  }

  async function transferirRegistros(sourcePeriodo, targetPeriodo) {
    setDataLoading(true);
    let response = await wsPost('sale/bono-zone/transferir-registros', {
      SourcePeriodo: sourcePeriodo,
      TargetPeriodo: targetPeriodo,
    });
    setDataLoading(false);

    if (response.success) {
      showNotify(response.message);
      console.log('Transferencia exitosa: ', response.data);
      loadCuotas(valueSearch);
    } else {
      showNotify(response.message, 'error');
      console.error('Error al transferir registros: ', response);
    }
  }

  const handleFilterChange = (value) => {
    const period = parseInt(moment(value.Periodo).format('YYYYMM'), 10);
    setCurrentPeriod(period);
  };

  return (
    <GridContainer>
      <Toasty action={notify} />
      {model.open ? (
        <Modal
          model={model}
          setOpen={setOpen}
          showNotify={showNotify}
          reload={() => loadCuotas(valueSearch)}
        />
      ) : undefined}

      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <AllowedGuard
              permission={ConstantPermissions.SALE_COMISIONES_STORE}
              component={
                <CardIcon color="primary">
                  <FileCopySharp style={{ color: 'white' }} />
                </CardIcon>
              }
            >
              <CardIcon
                onClick={() => setOpen({})}
                pointer="true"
                color={props.themeContext.buttonColorSuccess}
              >
                <Add />
              </CardIcon>
            </AllowedGuard>
            <div className={classes.cardIconTitle}>Listado de bonos para zonas
              <div className={classes.headerCard}>
                {valueSearch.zone_code || valueSearch.grupo_d_description || valueSearch.type_worker_code ? (
                  <>
                    {valueSearch.zone_code && valueSearch.grupo_d_description && valueSearch.type_worker_code ? (
                      <span className="totals">
                        Peso: {Math.max(pesoTotals[valueSearch.zone_code], pesoTotals[valueSearch.grupo_d_description], pesoTotals[valueSearch.type_worker_code] )|| '0.00'}%
                      </span>
                    ) : valueSearch.zone_code && valueSearch.grupo_d_description ? (
                      <span className="totals">Peso: {Math.max(pesoTotals[valueSearch.zone_code], pesoTotals[valueSearch.grupo_d_description] )|| '0.00'}%</span>
                    ) : valueSearch.grupo_d_description && valueSearch.type_worker_code ? (
                      <span className="totals">Peso: {Math.max(pesoTotals[valueSearch.grupo_d_description], pesoTotals[valueSearch.type_worker_code] )|| '0.00'}%</span>
                    ) : valueSearch.zone_code && valueSearch.type_worker_code ? (
                      <span className="totals">Peso: {Math.max(pesoTotals[valueSearch.zone_code], pesoTotals[valueSearch.type_worker_code] )|| '0.00'}%</span>
                    ) : valueSearch.zone_code ? (
                      <span className="totals">Peso zona: {pesoTotals[valueSearch.zone_code] || '0.00'}%</span>
                    ) : valueSearch.grupo_d_description ? (
                      <span className="totals">Peso grupo: {pesoTotals[valueSearch.grupo_d_description] || '0.00'}%</span>
                    ) : (
                      <span className="totals">Peso trabajador: {pesoTotals[valueSearch.type_worker_code] || '0.00'}%</span>
                    )}
                  </>
                ) : (
                  <span className="totals">Peso: 0%</span>
                )}
                <span className="totals">Total Comisión: {totalComision}</span>
              </div>
              <div className={classes.loader}>
                {dataLoading && <LoadingSpinner />}
              </div>
            </div>
          </CardHeader>
          <CardBody>
            <FilterCustom
              getFilter={loadCuotas}
              getValueSearch={(value) => {
                setValueSearch(value);
                handleFilterChange(value);
              }}
              date
              dateType="month"
              labelDate="Periodo"
              dateField="Periodo"
              zoneCode
              GroupCommisisions
              TypeWorker
            />
            <Button
              color="danger"
              onClick={() => {
                const sourcePeriod = moment(currentPeriod.toString(), "YYYYMM").subtract(1, "month").format("YYYYMM");
                transferirRegistros(Number(sourcePeriod), currentPeriod);
              }}>
              Inicializar bono de zonas
            </Button>
            <ReactTable
              excelName="bono_zonas"
              formatDate="DD-MM-YYYY"
              defaultWidth={1300}
              columns={columns}
              data={cuotas.map((item, i) => {
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <AllowedGuard
                        permission={ConstantPermissions.SALE_COMISIONES_DELETED}
                      >
                        <ButtonDelete
                          entity="sale/bono-zone"
                          id={item.id}
                          reload={() => {
                            setDataLoading(true);
                            loadCuotas(valueSearch).then(() => setDataLoading(false));
                          }}
                        />
                      </AllowedGuard>
                    </div>
                  ),
                  Periodo: item.Periodo,
                  description_zone: item.description_zone,
                  grupo_d_description: item.grupo_d_description,
                  tipo_t_description: item.tipo_t_description,
                  peso_string: item.peso,
                  importe_comision_string: item.importe_comision,
                  peso: (
                    <AllowedGuard
                      permission={ConstantPermissions.SALE_COMISIONES_UPDATE}
                      component={item.peso}
                    >
                      <TextField
                        fullWidth
                        type="number"
                        name="peso"
                        margin="normal"
                        value={item.peso || ''}
                        onChange={(e) => handleChange(item.id, 'peso', e.target.value)}
                        onBlur={(e) => updateCuota(item.id, 'peso', e.target.value)}
                      />
                    </AllowedGuard>
                  ),

                  importe_comision: (
                    <AllowedGuard
                      permission={ConstantPermissions.SALE_COMISIONES_UPDATE}
                      component={item.importe_comision}
                    >
                      <TextField
                        fullWidth
                        type="number"
                        name="importe_comision"
                        margin="normal"
                        value={item.importe_comision || ''}
                        onChange={(e) => handleChange(item.id, 'importe_comision', e.target.value)}
                        onBlur={(e) => updateCuota(item.id, 'importe_comision', e.target.value)}
                      />
                    </AllowedGuard>
                  ),
                  actions: '',
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
